import { render, staticRenderFns } from "./starUser.vue?vue&type=template&id=c4c2776a&scoped=true"
import script from "./starUser.vue?vue&type=script&lang=js"
export * from "./starUser.vue?vue&type=script&lang=js"
import style0 from "./starUser.vue?vue&type=style&index=0&id=c4c2776a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c2776a",
  null
  
)

export default component.exports